//import "./wdyr";
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import localizedFormat from "dayjs/plugin/localizedFormat";
import utc from "dayjs/plugin/utc";
import "dayjs/locale/en";
import { registerComponents } from "./componentRegistry";
import { initializeComponentRegistry } from "./utils/componentRegistry";
import { registerOccTransport } from "~/app/api/occ/registerOccTransport";
import { registerActiveCartPort } from "~/app/cart/registerActiveCartPort";
import "./styles/style_vendor.less";
import "./styles/style.less";
import { setupStore } from "~/app/store";
import { initializeCurrentCartContentsTracking } from "~/features/cart/cart/utils/trackCurrentCartContents";
import { getActiveCartData } from "~/features/cart/cart/api/CartView";
import { initializeConfiguratorCatalog } from "~/bridges/configurator/configuratorCatalog";
import { initializePageInitialDataLoader } from "~/app/api/pageData";
import { initializeAccountContextTransition } from "~/app/accountContextTransition";
import { initializeLogout } from "~/features/auth/api/doLogout";
import { initializeSessionExpiration } from "~/app/api/triggerSessionExpired";
import { createInitialHashScroller } from "~/common/createInitialHashScroller";
import { bindLmsLinkListener } from "~/features/lms/LmsLinkListener";
import { initZoovuTracking } from "~/app/analytics/zoovu/initZoovuTracking";
import "~/app/analytics";

import { LicenseInfo } from "@mui/x-license";
LicenseInfo.setLicenseKey(
  "80035531017802fcf9a758e1079b8621Tz0xMjAxOTQsRT0xNzkxNTkwMzk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj1RMy0yMDI0LEtWPTI=",
);

dayjs.extend(utc);
dayjs.extend(isSameOrBefore);
dayjs.extend(localizedFormat);
dayjs.locale({ ...dayjs.Ls.en, weekStart: 1 });

registerOccTransport();
initializeConfiguratorCatalog();
const store = setupStore();
initializeAccountContextTransition(store);
initializeLogout(store.dispatch);
initializeSessionExpiration(store);
initializePageInitialDataLoader(store.dispatch);
initializeCurrentCartContentsTracking({
  loadCartLineItems: async () => Object.values((await getActiveCartData())?.packageEntriesById ?? {}),
  getProductsByCode: () => store.getState().products.basic,
});
registerActiveCartPort();
initializeComponentRegistry(store);
registerComponents(store.dispatch);

window.SCHA.markReactReady();

// page is hidden until react loads
Array.from(document.querySelectorAll(".js__hidden-until-react")).forEach((el) => el.classList.add("react-loaded"));

window.addEventListener("load", () => {
  void initZoovuTracking();
});

createInitialHashScroller();

bindLmsLinkListener();
